@import "tailwindcss";

html, body, #root { height: 100%; margin: 0; padding: 0; }

body {
  font-family: -apple-system, "Apple SD Gothic Neo", "Malgun Gothic",
               "Pretendard", system-ui, sans-serif;
  background: #f8fafc;
  color: #1e293b;
  -webkit-font-smoothing: antialiased;
}

/* 인쇄 시 사이드바/필터 제거, 명세서만 출력 */
@media print {
  .no-print { display: none !important; }
  body { background: white !important; }
  main { padding: 0 !important; overflow: visible !important; }

  /* 거래명세서: A4 한 장에 한 시트. 색(파랑/빨강 테두리·도장) 그대로 출력. */
  @page { size: A4; margin: 0; }
  .invoice-sheet {
    box-shadow: none !important;
    margin: 0 auto !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  .invoice-sheet:last-child { page-break-after: auto !important; }
}

/* 숫자 입력(type=number) 업다운 화살표(스피너) 제거 — 단가·수량 등 */
.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
.no-spinner { -moz-appearance: textfield; appearance: textfield; }

/* 화면상 시트 구분용 그림자 */
.invoice-sheet { box-shadow: 0 1px 4px rgba(0,0,0,0.12); }

/* 날짜이동한 전표 행 — 스크롤 이동 후 잠깐 깜빡여 사용자 주의 환기(끝나면 정적 하이라이트 유지) */
@keyframes move-flash {
  0%, 100% { background-color: rgb(252 211 77); }  /* amber-300 */
  50%      { background-color: transparent; }
}
.animate-move-flash { animation: move-flash 0.7s ease-in-out 5; }

/* 토스트 알림 — 슬라이드-인 + 남은시간 진행바 */
@keyframes toast-in {
  from { opacity: 0; transform: translateX(14px) scale(0.97); }
  to   { opacity: 1; transform: none; }
}
@keyframes toast-bar { from { width: 100%; } to { width: 0%; } }
.toast-anim { animation: toast-in 0.18s cubic-bezier(0.16,1,0.3,1); }
@media (prefers-reduced-motion: reduce) {
  .toast-anim { animation: none; }
  .toast-bar  { animation: none !important; }
}
